import type { PosRepository } from '../../domain/interfaces/PosRepository';
import type { PosApprovalModel } from '../../domain/models/PosApprovalModel';

export class PosApprovalService {
  constructor(private readonly repository: PosRepository) {}

  getApprovalData(code: string): Promise<PosApprovalModel> {
    return this.repository.getApprovalData(code);
  }

  submitApprovalAction(aplrd: string, action: string): Promise<boolean> {
    return this.repository.submitApprovalAction(aplrd, action);
  }
}

export function createPosApprovalService(repository: PosRepository): PosApprovalService {
  return new PosApprovalService(repository);
}